/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Solution_CtaInputs */

const en_solution_cta = /** @type {(inputs: Solution_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sounds great!`)
};

const de_solution_cta = /** @type {(inputs: Solution_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klingt gut!`)
};

const zh_tw_solution_cta = /** @type {(inputs: Solution_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`聽起來不錯！`)
};

const zh_cn_solution_cta = /** @type {(inputs: Solution_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`听起来不错！`)
};

const es_solution_cta = /** @type {(inputs: Solution_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Suena muy bien!`)
};

const fr_solution_cta = /** @type {(inputs: Solution_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas mal du tout !`)
};

const it_solution_cta = /** @type {(inputs: Solution_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niente male!`)
};

const pt_br_solution_cta = /** @type {(inputs: Solution_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parece ótimo!`)
};

const ja_solution_cta = /** @type {(inputs: Solution_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいかも！`)
};

const ko_solution_cta = /** @type {(inputs: Solution_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`꽤 괜찮은데요!`)
};

const ru_solution_cta = /** @type {(inputs: Solution_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Звучит круто!`)
};

const th_solution_cta = /** @type {(inputs: Solution_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`น่าสนใจเลย!`)
};

const tr_solution_cta = /** @type {(inputs: Solution_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulağa güzel geliyor!`)
};

const ar_solution_cta = /** @type {(inputs: Solution_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يبدو رائعًا!`)
};

/**
* | output |
* | --- |
* | "Sounds great!" |
*
* @param {Solution_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const solution_cta = /** @type {((inputs?: Solution_CtaInputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Solution_CtaInputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_solution_cta(inputs)
	if (locale === "de") return de_solution_cta(inputs)
	if (locale === "zh_tw") return zh_tw_solution_cta(inputs)
	if (locale === "zh_cn") return zh_cn_solution_cta(inputs)
	if (locale === "es") return es_solution_cta(inputs)
	if (locale === "fr") return fr_solution_cta(inputs)
	if (locale === "it") return it_solution_cta(inputs)
	if (locale === "pt_br") return pt_br_solution_cta(inputs)
	if (locale === "ja") return ja_solution_cta(inputs)
	if (locale === "ko") return ko_solution_cta(inputs)
	if (locale === "ru") return ru_solution_cta(inputs)
	if (locale === "th") return th_solution_cta(inputs)
	if (locale === "tr") return tr_solution_cta(inputs)
	return ar_solution_cta(inputs)
});